import { z } from "zod";

export const PlaceSchema = z.object({
  id: z.string().optional(),
  displayName: z
    .object({
      text: z.string(),
      languageCode: z.string()
    })
    .optional(),
  formattedAddress: z.string().optional(),
  priceLevel: z.string().optional(),
  location: z
    .object({
      latitude: z.number(),
      longitude: z.number()
    })
    .optional(),
  rating: z.number().optional(),
  userRatingCount: z.number().optional(),
  photos: z
    .array(
      z.object({
        name: z.string(),
        widthPx: z.number(),
        heightPx: z.number()
      })
    )
    .optional()
});
export type Place = z.infer<typeof PlaceSchema>;

export const SearchPlaceResponseSchema = z.object({
  places: z.array(PlaceSchema)
});

export type SearchPlaceResponse = z.infer<typeof SearchPlaceResponseSchema>;

export const AddressComponentSchema = z.object({
  longText: z.string().optional(),
  shortText: z.string().optional(),
  languageCode: z.string().optional(),
  types: z.array(z.string())
});
export type AddressComponent = z.infer<typeof AddressComponentSchema>;

export const PlaceDetailsSchema = z.object({
  id: z.string().optional(),
  displayName: z
    .object({
      text: z.string(),
      languageCode: z.string()
    })
    .optional(),
  formattedAddress: z.string().optional(),
  location: z
    .object({
      latitude: z.number(),
      longitude: z.number()
    })
    .optional(),
  addressComponents: z.array(AddressComponentSchema).optional(),
  plusCode: z
    .object({
      globalCode: z.string().optional(),
      compoundCode: z.string().optional()
    })
    .optional()
});
export type PlaceDetails = z.infer<typeof PlaceDetailsSchema>;

export interface SearchPlaceOptions {
  textQuery: string;
  maxResultCount?: number;
  locationBias?: {
    circle?: {
      center: {
        latitude: number;
        longitude: number;
      };
      radius: number;
    };
  };
  languageCode?: string;
  fieldMask?: string[];
}

export interface GetPlaceDetailsOptions {
  placeId: string;
  languageCode?: string;
  fieldMask?: string[];
}

// Request schemas for API validation
export const SearchPlaceRequestSchema = z.object({
  textQuery: z.string().min(1),
  maxResultCount: z.number().int().min(1).max(20).optional(),
  locationBias: z
    .object({
      circle: z
        .object({
          center: z.object({
            latitude: z.number(),
            longitude: z.number()
          }),
          radius: z.number().positive()
        })
        .optional()
    })
    .optional(),
  languageCode: z.string().optional(),
  fieldMask: z.array(z.string()).optional()
});

export type SearchPlaceRequest = z.infer<typeof SearchPlaceRequestSchema>;

export const GetPlaceDetailsRequestSchema = z.object({
  placeId: z.string().min(1),
  languageCode: z.string().optional(),
  fieldMask: z.array(z.string()).optional()
});

export type GetPlaceDetailsRequest = z.infer<typeof GetPlaceDetailsRequestSchema>;
